<template>
	<div class="display-flex flex-column flex-justify-center">
		<div v-if="!isVirtualProject && !isPlacementMode" class="location-description">SPACE</div>
		<div class="project-selector-title first-letter-uppercase flex-row display-flex flex-align-center">
			<template v-if="isPlacementMode">
				<SIcon class="mr-2" v-if="slug" :name="slug" width="16" height="16" />
			</template>
			<template v-else>
				<SpaceIconCard v-if="!isVirtualProject" class="mr-2">
					<SIcon :name="projectIconIndicatorName" width="10" />
				</SpaceIconCard>
			</template>
			{{ title }}
		</div>
		<h5 v-if="isVirtualProject && isDescriptionValid" class="description text-overflow-ellipsis">{{ description }}</h5>
	</div>
</template>

<script>
import SpaceIconCard from '@/views/AppLayout/ManageAndCreate/SpaceIconCard.vue';
export default {
	name: 'ProjectSelectorTitle',
	components: { SpaceIconCard },
	props: {
		slug: { type: String },
		title: { type: String },
		description: { type: String },
		isPlacementMode: { type: Boolean },
		isVirtualProject: { type: Boolean },
		isPersonalProject: { type: Boolean },
	},
	computed: {
		projectIconIndicatorName() {
			return `${this.isPersonalProject ? 'personal' : 'collaborative'}-space`;
		},
		isDescriptionValid() {
			return this.description && this.description.length > 0 && this.description !== 'undefined';
		},
	},
};
</script>
<style scoped lang="scss">
.project-selector-title {
	font-size: 14px;
}
.description {
	font-size: 12px;
}
.location-description {
	font-size: 11px;
	color: #8f95ab;
}
</style>
